import u from "./_baseIsEqualDeep.js";
import r from "./isObjectLike.js";
function m(i, n, f, s, t) {
  return i === n ? !0 : i == null || n == null || !r(i) && !r(n) ? i !== i && n !== n : u(i, n, f, s, m, t);
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseIsEqual.js
// module id = 868
// module chunks = 41